import React from 'react';
import { Switch } from 'react-router-dom';
import UpdateUser from './user/user-update';
import UserDetail from './user/user-detail';

// tslint:disable-next-line:no-unused-variable
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

/* jhipster-needle-add-route-import - JHipster will add routes here */

const Routes = ({ match }) => (
  <div>
    <Switch>
      {/* prettier-ignore */}
      {/* jhipster-needle-add-route-path - JHipster will add routes here */}
      <ErrorBoundaryRoute path={`${match.url}/user-detail`} component={UserDetail} />
      <ErrorBoundaryRoute path={`${match.url}/user-update`} component={UpdateUser} />
    </Switch>
  </div>
);

export default Routes;
